


























import { computed, defineComponent, inject, ref } from '@nuxtjs/composition-api';

import { useSeoMeta } from '~/features/seo';
import { Category } from '~/features/categories';
import { CATEGORY_CONTEXT } from '~/utils/provides';
import { MappedAggregation } from '~/features/facets';
import { useRouter } from '~/features/router';
import { useCategoryOffers } from '~/features/offers';
import { serializeObjectToParams } from '~/utils/route';

const options = {
  supportOffers: true,
};
export default defineComponent({
  setup() {
    const category = inject(CATEGORY_CONTEXT) as Category;
    const { redirect, query } = useRouter();

    const facets = ref<MappedAggregation[]>([]);
    const { offers: banners, listingAds, isFetching: isFetchingCategoryOffer } = useCategoryOffers(
      computed(() => ({ categoryId: category.id }))
    );
    function onSelectCategory(url: string) {
      /**
       * set the selected category
       */
      redirect(`/${url}${serializeObjectToParams(query.value)}`);
    }

    useSeoMeta(
      computed(() => ({
        title: category.meta_title || category.name,
        description: category.meta_description,
        keywords: category.meta_keywords,
        image: category.image,
      }))
    );
    return {
      category,
      facets,
      onSelectCategory,
      options,
      banners,
      listingAds,
      isFetchingCategoryOffer,
    };
  },
  head: {},
});
